const basePath = 'exam'
export const QUIZ_ROUTER_EXAM = {
	test: `${basePath}/test/:alias`,
	result: id => `${basePath}/result/${id ?? ':id'}`,
	admin_result: id => `${basePath}/admin/result/${id ?? ':id'}`,
	room: alias => `room/${alias || ':alias'}`,
	search: `${basePath}/search`,
	download: `${basePath}/download/:alias`,
	channel: `${basePath}/channel/:alias`,
	ranking: `${basePath}/ranking`,
	category: `${basePath}/category/:type/:id`,
	explore: `${basePath}/explore`
}

export const QUIZ_TRANSLATE_EXAM = `common`
